import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject ,  Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../../app.constants';
import { IonicAngular4CacheService } from 'ionic-angular4-cache';

@Injectable({
  providedIn: 'root'
})
export class VendorServiceService {

  constructor(
    private _http: HttpClient,
    private config: Configuration,
    public ionicAngular4Cache: IonicAngular4CacheService
  ) { }

  public search(skip, limit, query, sort) {
    return new Promise((ok, notOk) => {
      const queryData = { 'query': query, 'sort': sort };
      const searchOrganizationObservable = this._http.post(`${this.config.ServerApiUrl}/vendors/search/${skip * limit}/${limit}`,
      queryData);
      searchOrganizationObservable.subscribe(data => {
        this.ionicAngular4Cache.saveItemOld(`vendorSearch`, data);
        ok(data);
      });
    });
  }

  public checkMassDeduplication(vendors) {
    return new Promise((ok, notOk) => {
        this._http.post(`${this.config.ServerApiUrl}/vendors/checkMassDeduplication`,
        {vendors: vendors}).subscribe(data => {
          ok(data);
        });
    });
  }

  public checkMassSimilarVendors(vendors) {
    return new Promise((ok, notOk) => {
        this._http.post(`${this.config.ServerApiUrl}/vendors/checkMassSimilarVendors`,
        {vendors: vendors}).subscribe(data => {
          ok(data);
        });
    });
  }

  public getMassImportTemplateFile() {
    return new Promise((ok, notOk) => {
        this._http.post(`${this.config.ServerApiUrl}/vendors/getMassImportTemplateFile`,
        {}).subscribe(data => {
          ok(data);
        });
    });
  }

  public checkMassApacVendorPossibilities(vendors) {
    return new Promise((ok, notOk) => {
        this._http.post(`${this.config.ServerApiUrl}/vendors/checkMassApacVendorPossibilities`,
        {vendors: vendors}).subscribe(data => {
          ok(data);
        });
    });
  }

  public importMassVendors(vendors, exportInfo) {
    return new Promise((ok, notOk) => {
        this._http.post(`${this.config.ServerApiUrl}/vendors/importMassVendors`,
        {vendors: vendors, exportInfo: exportInfo}).subscribe(data => {
          ok(data);
        });
    });
  }

  public powerSearch(skip, limit, searchTerm) {
    return new Promise((ok, notOk) => {
      const searchOrganizationObservable = this._http.post(`${this.config.ServerApiUrl}/vendors/powersearch/${skip * limit}/${limit}`,
      {searchTerm: searchTerm});
      searchOrganizationObservable.subscribe(data => {
        ok(data);
      });
    });
  }

  public getSingleVendor(id) {
    return new Promise((ok, notOk) => {
      if(id && id != null && id != undefined && id != 'create'){
        const searchOrganizationObservable = this._http.post(`${this.config.ServerApiUrl}/vendors/getSingleVendor`,
        {vendorId: id});
        searchOrganizationObservable.subscribe(data => {
          ok(data);
        });
      } else {
        ok({});
      }
    });
  }

  public updateVendor(vendorId, vendorObj) {
    return new Promise((ok, notOk) => {
        this._http.post(`${this.config.ServerApiUrl}/vendors/updateVendor`,
        {vendorId: vendorId, vendorObj: vendorObj}).subscribe(data => {
          ok(data);
        });
    });
  }

  public getCreateVendorGroupInfo() {
    return new Promise((ok, notOk) => {
        this._http.post(`${this.config.ServerApiUrl}/vendors/getCreateVendorGroupInfo`,
        {}).subscribe(data => {
          ok(data);
        });
    });
  }

  public mergeVendors(vendorId, mergeIds, type='merge') {
    return new Promise((ok, notOk) => {
        this._http.post(`${this.config.ServerApiUrl}/vendors/mergeVendors`,
        {vendorId: vendorId, mergeIds: mergeIds, type: type}).subscribe(data => {
          ok(data);
        });
    });
  }

  public generateSoneparId(vendorId, country) {
    return new Promise((ok, notOk) => {
        this._http.post(`${this.config.ServerApiUrl}/vendors/generateSoneparId`,
        {vendorId, country}).subscribe(data => {
          ok(data);
        });
    });
  }

  public createVendor(vendorObj) {
    return new Promise((ok, notOk) => {
        this._http.post(`${this.config.ServerApiUrl}/vendors/createVendor`,
        {vendorObj: vendorObj}).subscribe(data => {
          ok(data);
        });
    });
  }

  public getPossibleDuplicatesForNewVendor(apacName, erpId, erpNameEng, taxId, busiRegId, busiLicenId, invoiceCountry) {
    return new Promise((ok, notOk) => {
        this._http.post(`${this.config.ServerApiUrl}/vendors/getPossibleDuplicatesForNewVendor`,
        {apacName, erpId, erpNameEng, taxId, busiRegId, busiLicenId, invoiceCountry}).subscribe(data => {
          ok(data);
        });
    });
  }

  public changeArchiveStatus(vendorId, status) {
    return new Promise((ok, notOk) => {
        this._http.post(`${this.config.ServerApiUrl}/vendors/changeArchiveStatus`,
        {vendorId: vendorId, status: status}).subscribe(data => {
          ok(data);
        });
    });
  }

  public getLegalEntities() {
    return new Promise((ok, notOk) => {
        this._http.post(`${this.config.ServerApiUrl}/vendors/getLegalEntities`,
        {}).subscribe(data => {
          ok(data);
        });
    });
  }

  public getVendorCountries (soa, country, groupCountry) {
    return this._http.post(`${this.config.ServerApiUrl}/vendors/getVendorCountries`, {soa, country, groupCountry});
  }

  public getVendorRuleCountries () {
    return this._http.post(`${this.config.ServerApiUrl}/vendors/getVendorRuleCountries`, {});
  }

  public getVendorRules(query) {
    return new Promise((ok, notOk) => {
        this._http.post(`${this.config.ServerApiUrl}/vendors/getVendorRules`,
        {query: query}).subscribe(data => {
          ok(data);
        });
    });
  }

  public getSingleVendorRule(ruleId) {
    return new Promise((ok, notOk) => {
        this._http.post(`${this.config.ServerApiUrl}/vendors/getSingleVendorRule`,
        {ruleId: ruleId}).subscribe(data => {
          ok(data);
        });
    });
  }

  public addVendorRule(query) {
    return new Promise((ok, notOk) => {
        this._http.post(`${this.config.ServerApiUrl}/vendors/addVendorRule`,
        {query: query}).subscribe(data => {
          ok(data);
        });
    });
  }

  public updateVendorRule(ruleId, query) {
    return new Promise((ok, notOk) => {
        this._http.post(`${this.config.ServerApiUrl}/vendors/updateVendorRule`,
        {query: query, ruleId: ruleId}).subscribe(data => {
          ok(data);
        });
    });
  }
}
